var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77992 9.33337H2.66659C1.93325 9.33337 1.33325 9.93337 1.33325 10.6667V14.6667H5.77992V9.33337Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88677 6.66663H7.10677C6.37344 6.66663 5.77344 7.26663 5.77344 7.99996V14.6666H10.2201V7.99996C10.2201 7.26663 9.62677 6.66663 8.88677 6.66663Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.3334H10.22V14.6667H14.6666V12.6667C14.6666 11.9334 14.0666 11.3334 13.3333 11.3334Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34658 1.38L8.69991 2.08667C8.74658 2.18667 8.87324 2.28 8.97991 2.29333L9.61991 2.4C10.0266 2.46667 10.1266 2.76666 9.83324 3.05332L9.33324 3.55332C9.24658 3.63999 9.19991 3.8 9.22658 3.91333L9.36658 4.52667C9.47991 5.01334 9.21991 5.20001 8.79324 4.94668L8.19324 4.59334C8.08658 4.52668 7.90658 4.52668 7.79991 4.59334L7.19991 4.94668C6.77324 5.20001 6.51324 5.01334 6.62657 4.52667L6.76658 3.91333C6.79324 3.8 6.74658 3.63332 6.65991 3.55332L6.16658 3.06C5.87324 2.76666 5.96658 2.47332 6.37991 2.40666L7.01991 2.30001C7.12657 2.28001 7.25324 2.18668 7.29991 2.09334L7.65324 1.38666C7.84658 0.99999 8.15324 1 8.34658 1.38Z",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.91f97cf95a567b1f73be2e9d63a041dd.svg";
export { ForwardRef as ReactComponent };